// const basePath1 = '/glisting_api/v1.0/gListing';
const basePath1 = '/listing_api/v1.0/gListing';
const basePath2 = '/listing_api/v1.0/listing';

export const PDP_SINGLE = `${basePath1}/single`;
export const PDP_CONTATC_INFO = `${basePath1}/contactInfo`;
export const SIMILAR = `${basePath2}/similar`;
export const TRACK = (id: string) =>
  `${basePath1}/single/track?Identifier=${id}`;